module.exports = __webpack_public_path__ + "static/img/icon_passcard_label.94c8ee4e.png";